import InputLabel, { InputLabelSelect } from "../../components/inputLabel";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import preCadastroActions from "../../redux/preCadastro/actions";
import { StoreState } from "../../redux/reduxTypes";
import { PreCadastroState } from "../../types/state.types";
import { DivisoriaSecao, TituloSecao } from "./styled";

function EnderecoContatoPreCadastro() {
  const dispatch = useDispatch();

  const { dados, dadosIniciais } = useSelector<StoreState, PreCadastroState>(
    (state) => state.preCadastroState
  );

  const atualizarDadosPreCadastro = useCallback(
    (dadosForm: object) => {
      dispatch(
        preCadastroActions.setDados({
          ...dados,
          ...dadosForm,
        })
      );
    },
    [dados, dispatch]
  );

  return (
    <DivisoriaSecao>
      <TituloSecao>Endereço e Contato</TituloSecao>

      <InputLabel
        labelText="E-Mail"
        labelId="eMail"
        type="email"
        value={dados.email}
        onChange={(value) => {
          atualizarDadosPreCadastro({ email: value });
        }}
        required
        column
        maxLength={75}
      />

      <InputLabel
        labelText="Telefone (Celular)"
        labelId="telefoneCelular"
        placeholder="(85) 9 9999-9999"
        mask="(99) 9 9999-9999"
        type="number"
        value={dados.dddTelefoneCelular + dados.telefoneCelular}
        onChange={(value) => {
          if (value.length <= 2) {
            atualizarDadosPreCadastro({
              dddTelefoneCelular: value,
              telefoneCelular: "",
            });
          } else if (value.length <= 11) {
            atualizarDadosPreCadastro({
              dddTelefoneCelular: value.substring(0, 2),
              telefoneCelular: value.substring(2),
            });
          }
        }}
        column
        required
        maxLength={20}
      />
      <InputLabel
        labelText="Telefone (Residencial)"
        labelId="telefoneResidencial"
        placeholder="(85) 9999-9999"
        mask="(99) 9999-9999"
        type="number"
        value={dados.dddTelefoneResidencial + dados.telefoneResidencial}
        onChange={(value) => {
          if (value.length <= 2) {
            atualizarDadosPreCadastro({
              dddTelefoneResidencial: value,
              telefoneResidencial: "",
            });
          } else if (value.length <= 11) {
            atualizarDadosPreCadastro({
              dddTelefoneResidencial: value.substring(0, 2),
              telefoneResidencial: value.substring(2),
            });
          }
        }}
        column
        maxLength={20}
      />

      <InputLabelSelect
        labelText="Nacionalidade"
        labelId="paisID"
        value={dados.paisID}
        onChange={(value) => {
          atualizarDadosPreCadastro({ paisID: Number(value) });
        }}
        required
        options={
          dadosIniciais
            ? dadosIniciais.ListaNacionalidade.map((item) => {
                return {
                  value: item.ID,
                  label: item.Nome,
                };
              })
            : []
        }
        column
      />

      <InputLabel
        labelText="Código Postal (CEP)"
        labelId="cep"
        mask="99999-999"
        type="number"
        value={dados.cep}
        onChange={(value) => {
          if (value.length <= 8) atualizarDadosPreCadastro({ cep: value });
        }}
        required
        column
        maxLength={10}
      />

      <InputLabelSelect
        labelText="UF Atual"
        labelId="ufIDEndereco"
        value={dados.ufIDEndereco}
        onChange={(value) => {
          atualizarDadosPreCadastro({ ufIDEndereco: value });
        }}
        required
        options={
          dadosIniciais
            ? [
                { ID: "", Nome: " (( SELECIONAR )) " },
                ...dadosIniciais.ListaUF,
              ].map((item) => {
                return {
                  value: item.ID,
                  label: item.Nome,
                };
              })
            : []
        }
        column
      />

      <InputLabel
        labelText="Cidade"
        labelId="nomeCidade"
        type="text"
        value={dados.nomeCidade}
        onChange={(value) => {
          atualizarDadosPreCadastro({ nomeCidade: value });
        }}
        required
        column
        maxLength={90}
      />

      <InputLabel
        labelText="Bairro"
        labelId="bairro"
        type="text"
        value={dados.bairro}
        onChange={(value) => {
          atualizarDadosPreCadastro({ bairro: value });
        }}
        required
        column
        maxLength={90}
      />

      <InputLabel
        labelText="Logradouro (Rua/avenida)"
        labelId="logradouro"
        type="text"
        value={dados.logradouro}
        onChange={(value) => {
          atualizarDadosPreCadastro({ logradouro: value });
        }}
        required
        column
        maxLength={120}
      />

      <InputLabel
        labelText="Número da Casa/Apartamento"
        labelId="numeroLogradouro"
        type="text"
        value={dados.numeroLogradouro}
        onChange={(value) => {
          atualizarDadosPreCadastro({ numeroLogradouro: value });
        }}
        required
        column
        maxLength={10}
      />

      <InputLabel
        labelText="Complemento"
        labelId="complemento"
        type="text"
        value={dados.complemento}
        onChange={(value) => {
          atualizarDadosPreCadastro({ complemento: value });
        }}
        column
        maxLength={49}
      />
    </DivisoriaSecao>
  );
}

export default EnderecoContatoPreCadastro;
